export interface LangOption {
  label: string
  value: string
  showByRouteNames?: string[]
}

export enum Lang {
  English = 'en',
  English_United_Kingdom = 'en-GB',
  English_United_States = 'en-US',
  English_Australia = 'en-AU',
  English_Canada = 'en-CA',
  Japanese = 'ja',
  French = 'fr',
  German = 'de',
  Spanish = 'es',
  Spanish_MX = 'es-MX',
  Spanish_419 = 'es-419',
  Italian = 'it',
  Korean = 'ko',
  Turkish = 'tr',
  Russian = 'ru',
  Thai = 'th',
  Vietnamese = 'vi',
  Indonesian = 'id',
  Malay = 'ms',
  Arabic = 'ar',
  SimplifiedChinese = 'zh',
  Portuguese = 'pt',
  Portuguese_Brasil = 'pt-BR',
  Swedish = 'sv-SE',
  Polish = 'pl-PL',
  Czech = 'cs-CZ',
}

export enum LangLabel {
  SimplifiedChinese = '简体中文',
  English = 'English',
  English_United_Kingdom = 'English - United Kingdom',
  English_United_States = 'English - United States',
  English_Australia = 'English - Australia',
  English_Canada = 'English - Canada',
  Japanese = '日本語',
  French = 'Français',
  German = 'Deutsch',
  Spanish = 'Español',
  Spanish_MX = 'Español - México',
  Spanish_419 = 'Español - América Latina',
  Italian = 'Italiano',
  Korean = '한국어',
  Turkish = 'Türkçe',
  Russian = 'Русский',
  Thai = 'ภาษาไทย',
  Vietnamese = 'Tiếng Việt',
  Indonesian = 'Bahasa Indonesia',
  Malay = 'Melayu',
  Arabic = 'العربية',
  Portuguese = 'Português',
  Portuguese_Brasil = 'Português - Brasil',
  Swedish = 'Svenska',
  Polish = 'Polski',
  Czech = 'Čeština',
}

export const LANGUAGE_LIST: LangOption[] = [
  { label: LangLabel.English, value: Lang.English },
  { label: LangLabel.English_United_States, value: Lang.English_United_States },
  {
    label: LangLabel.English_United_Kingdom,
    value: Lang.English_United_Kingdom,
    // showByRouteNames: ['ecommerce-new-region'],
  },
  { label: LangLabel.English_Australia, value: Lang.English_Australia },
  { label: LangLabel.English_Canada, value: Lang.English_Canada },
  { label: LangLabel.Japanese, value: Lang.Japanese },
  { label: LangLabel.French, value: Lang.French },
  { label: LangLabel.German, value: Lang.German },
  { label: LangLabel.Spanish, value: Lang.Spanish },
  { label: LangLabel.Spanish_MX, value: Lang.Spanish_MX },
  { label: LangLabel.Spanish_419, value: Lang.Spanish_419 },
  { label: LangLabel.Italian, value: Lang.Italian },
  { label: LangLabel.Korean, value: Lang.Korean },
  { label: LangLabel.Turkish, value: Lang.Turkish },
  { label: LangLabel.Russian, value: Lang.Russian },
  { label: LangLabel.Thai, value: Lang.Thai },
  { label: LangLabel.Vietnamese, value: Lang.Vietnamese },
  { label: LangLabel.Indonesian, value: Lang.Indonesian },
  { label: LangLabel.Malay, value: Lang.Malay },
  { label: LangLabel.Arabic, value: Lang.Arabic },
  {
    label: LangLabel.SimplifiedChinese,
    value: Lang.SimplifiedChinese,
    showByRouteNames: ['lead-form-sign', 'success/leave-info'],
  },
  { label: LangLabel.Portuguese, value: Lang.Portuguese },
  { label: LangLabel.Portuguese_Brasil, value: Lang.Portuguese_Brasil },
  { label: LangLabel.Swedish, value: Lang.Swedish },
  { label: LangLabel.Polish, value: Lang.Polish },
  { label: LangLabel.Czech, value: Lang.Czech },
]

export const getLanguages = (routeName?: string | null) =>
  LANGUAGE_LIST.filter((item) =>
    item.showByRouteNames
      ? item.showByRouteNames.includes(routeName || '')
      : true
  )

export const countryLangMap: Record<string, string> = {
  IN: Lang.English,
  VN: Lang.Vietnamese,
  JP: Lang.Japanese,
  FR: Lang.French,
  DE: Lang.German,
  ES: Lang.Spanish,
  IT: Lang.Italian,
  KR: Lang.Korean,
  TR: Lang.Turkish,
  RU: Lang.Russian,
  TH: Lang.Thai,
  ID: Lang.Indonesian,
  MY: Lang.Malay,
  AR: Lang.Arabic,
  SE: Lang.Swedish,
  PL: Lang.Polish,
  CZ: Lang.Czech,
  default: Lang.English,
}

// 特殊语言的map映射
export const specialLangMap: Record<string, string> = {
  [Lang.Portuguese_Brasil]: Lang.Portuguese,
  [Lang.Spanish_419]: Lang.Spanish,
  [Lang.Spanish_MX]: Lang.Spanish,
}

// 在拉取到 starling 后，存在前端 i18n messages 对象中的 key 需要转回去的语言 map
export const specStarlingLangToLocalLangMap: Record<string, string> = {
  [Lang.Portuguese_Brasil]: Lang.Portuguese,
}

export const getRealLang = (lang: string) => {
  return specialLangMap[lang] || lang || countryLangMap.default
}

export const getRevertLang = (lang: string) => {
  return specStarlingLangToLocalLangMap[lang] || lang || countryLangMap.default
}

// 兼容path上的语言, 比如 /tt4bnew/pt , 正常的语言都放在query内 /tt4b?lang=pt
export const getUrlLang = (lang: string) => {
  if (!lang) return ''
  return countryLangMap[lang.toUpperCase()] || lang
}
